<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'configure',
    subject: 'Workflow',
  },
})

const page = {
  groupTitle: 'Administrasi',
  icon: 'ri-git-branch-line',
  color: 'error',
  title: 'Setup Approval Flow',
  description: 'Menentukan urutan dan siapa saja yang menyetujui suatu dokumen/CAPA.',
  purpose: 'Panduan mengatur alur persetujuan berjenjang sebelum staf mulai mengajukan dokumen/CAPA untuk direview.',
  concept: [
    {
      icon: 'ri-flow-chart',
      title: 'Flow = Urutan Langkah Persetujuan',
      text: 'Satu Approval Flow terdiri dari beberapa langkah berurutan (mis. Kepala Unit → Ketua Tim Mutu → Direktur). Setiap langkah punya penyetuju sendiri, ditentukan lewat Role atau orang tertentu (PIC).',
    },
  ],
  steps: [
    { title: 'Buka menu Administrasi → Approval Flow', detail: 'Klik "+ Tambah Flow".' },
    { title: 'Pilih jenis objek yang memakai flow ini', detail: 'Mis. "Document" atau "CAPA".' },
    { title: 'Tambahkan langkah persetujuan satu per satu', detail: 'Tiap langkah: pilih apakah disetujui oleh Role tertentu, atau oleh satu orang PIC spesifik.' },
    { title: 'Atur urutan langkah dengan benar', detail: 'Ini menentukan siapa yang harus menyetujui lebih dulu sebelum ke langkah berikutnya.' },
    { title: 'Klik "Simpan"', detail: 'Flow langsung aktif untuk dokumen/CAPA baru yang diajukan setelahnya.' },
  ],
  warning: 'Pastikan flow sudah dibuat SEBELUM staf mulai mengajukan dokumen untuk direview — kalau belum ada flow yang sesuai, tombol "Ajukan Review" akan gagal.',
  tips: [
    'Setup Approval Flow adalah salah satu langkah wajib di checklist Onboarding — kerjakan di awal instalasi, bukan belakangan.',
  ],
  faq: [
    { q: 'Bisakah satu jenis objek (mis. Dokumen) punya lebih dari satu Approval Flow?', a: 'Ya, sistem akan memakai flow yang aktif dan sesuai — hubungi tim teknis kalau Anda butuh flow berbeda untuk kategori dokumen yang berbeda.' },
  ],
  related: [
    { title: 'Approval Dokumen', sub: 'Cara kerja dari sisi penyetuju', icon: 'ri-checkbox-circle-line', color: 'success', to: { name: 'help-dokumen-approval-dokumen' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
